import React from "react";
import { Button, Space, Typography } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";

const { Text } = Typography;

const SelectedServiceActionsCard = ({ selectedService, form, setEmbarkationModal, handleStartStopService }) => {
  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <Space orientation="vertical" size={8} style={{ width: "100%" }}>
        <div>
          <EnvironmentOutlined style={{ color: "#52c41a", marginRight: 8 }} />
          <Text strong style={{ color: "#262626" }}>
            Embarque:{" "}
          </Text>
          <Text style={{ color: "#595959" }}>{selectedService.pier_origin?.name || "N/A"}</Text>
        </div>
        <div>
          <EnvironmentOutlined style={{ color: "#ff4d4f", marginRight: 8 }} />
          <Text strong style={{ color: "#262626" }}>
            Desembarque:{" "}
          </Text>
          <Text style={{ color: "#595959" }}>{selectedService.pier_destination?.name || "N/A"}</Text>
        </div>
      </Space>
      <Space orientation="horizontal">
        {selectedService.serviceStatus !== "completed" && (
          <Button
            size="large"
            onClick={() => {
              setEmbarkationModal(true);
              form.setFieldsValue({
                embarked_count: selectedService.embarked_count || 0,
              });
            }}
          >
            Confirmar Total de Embarques
          </Button>
        )}
        {selectedService?.serviceStatus !== "running" && selectedService?.serviceStatus !== "completed" && (
          <Button
            size="large"
            onClick={() => {
              handleStartStopService("start");
            }}
            type="primary"
          >
            Iniciar Serviço
          </Button>
        )}
        {selectedService.serviceStatus === "running" && (
          <Button
            onClick={() => {
              handleStartStopService("stop");
            }}
            size="large"
          >
            Terminar Serviço
          </Button>
        )}
      </Space>
    </div>
  );
};

export default SelectedServiceActionsCard;
